import {Check} from "../types/type-checking";

export function scrollElementIntoViewSmooth(element: any, options?: ScrollIntoViewOptions): void {
    if(!Check.isFunction(element?.scrollIntoView)) {
        return;
    }

    options = {
        behavior: "smooth",
        block: "start",
        inline: "center",
        ...options
    };
    element.scrollIntoView(options);

}
